import { makeStyles } from "@mui/styles";
import { COLORS } from "../../../constant/colors";

export default makeStyles(() => ({
  myCol: {
    padding: "15px !important",
    textAlign: "center",
    transition: "all 0.3s ease-in-out",
    "& h3": {
      transition: "all 0.3s ease-in-out",
    },
    "&:hover": {
      transform: "translateY(-10px)",
      "& h3": {
        color: COLORS.secondary,
      },
    },
    "@media (max-width: 767px)": {
      padding: "0px 8px 20px !important",
      "& h3": {
        fontSize: "14px !important",
        marginBottom: "2px !important",
        fontWeight: "400 !important",
      },
    },
    "@media (max-width: 600px)": {
      "&:hover": {
        transform: "translateY(0)",
      },
    },
    "@media (max-width: 467px)": {
      "& h3": {
        fontSize: "12px !important",
      },
    },
  },
  deliveryTime: {
    fontSize: "13px",
    color: "#777777",
    marginBottom: "14px !important",
  },
  productImgBlock: {
    border: "1px solid #ab283d",
    padding: 15,
    borderRadius: "120px 120px 0 120px",
    overflow: "hidden",
    aspectRatio: "1/1",
    "@media (max-width: 600px)": {
      padding: 10,
      borderRadius: "70px 70px 0 70px",
      marginBottom: 12,
    },
  },
  productImg: {
    width: "100%",
    borderRadius: "110px 110px 0 110px",
    userSelect: "none",
    "@media (max-width: 600px)": {
      borderRadius: "60px 60px 0 60px",
    },
  },
  content: {
    textAlign: "center",
    marginTop: 20,
    "& h3": {
      color: `${COLORS.black} !important`,
      fontSize: "17px !important",
      fontWeight: "500 !important",
    },
    "@media (max-width: 767px)": {
      marginTop: 10,
    },
    "@media (max-width: 600px)": {
      "& h3": {
        fontSize: "14px !important",
        marginBottom: "8px !important",
      },
    },
  },
  rating: {
    marginTop: -4,
    "@media (max-width: 767px)": {
      marginTop: 0,
    },
  },
  ratingStar: {
    color: COLORS.secondary,
    "@media (max-width: 475px)": {
      fontSize: "14px !important",
    },
  },
  star: {
    color: COLORS.secondary,
    "@media (max-width: 767px)": {
      fontSize: "12px !important",
    },
  },
  priceSec: {
    "@media (max-width: 600px)": {
      marginTop: -5,
    },
  },
  del: {
    fontSize: 15,
    fontFamily: "Poppins",
    fontWeight: "500",
    marginRight: 5,

    color: COLORS.lightGrey1,
    "@media (max-width: 767px)": {
      fontSize: 13,
    },
  },
  price: {
    color: COLORS.primary,
    fontSize: 16,
    fontFamily: "Poppins",
    fontWeight: "500",
    "@media (max-width: 767px)": {
      fontSize: 14,
    },
  },
}));
